module.exports = __webpack_public_path__ + "static/media/20.1b3d8835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/20.jpg
// module id = 479
// module chunks = 0